import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

type Props = {
    to: string;
};

export default function BackToAllVisitsButton({ to }: Props) {
    const { t } = useTranslation("project");

    return (
        <Button variant="contained" component={Link} to={to}>
            {t("projectReviewVisitV2.backToOverviewBtn")}
        </Button>
    );
}
